import { useEffect } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import AtlassianSystemRemoteFrontendSdk from '../remote-sdk';
import useRemoteModuleLoader from '../use-remote-module-loader';
var preloadedModuleMap = new WeakMap();

/**
 * Create an SDK instance for a given plugin aand cache it in the WeakMap so that if a plugin is no longer referenced
 * we clean up the sdk from the cache
 *
 * @param remotePlugin
 */
var cacheAndGetSdkForPlugin = function cacheAndGetSdkForPlugin(remotePlugin) {
  var cachedSdk = preloadedModuleMap.get(remotePlugin);
  if (cachedSdk) {
    return cachedSdk;
  }
  var sdk = new AtlassianSystemRemoteFrontendSdk(remotePlugin);
  preloadedModuleMap.set(remotePlugin, sdk);
  return sdk;
};

/**
 * Preload a plugin by instantiating it and firing off the request for the module in the registry
 *
 * @param remotePlugin
 * @param options
 */
var useRemoteModule = function useRemoteModule(remotePlugin, options) {
  var remoteFrontendSdk = cacheAndGetSdkForPlugin(remotePlugin);
  useRemoteModuleLoader(remoteFrontendSdk, options);
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  useEffect(function () {
    var analyticsEvent = createAnalyticsEvent({
      action: 'rendered',
      actionSubject: 'remoteModule',
      actionSubjectId: 'useRemoteModule',
      attributes: {
        dimensions: remotePlugin.dimensions,
        plugin: remotePlugin.constructor.name
      }
    });
    analyticsEvent.fire(options === null || options === void 0 ? void 0 : options.analyticsChannel);
  }, [createAnalyticsEvent, remotePlugin, options === null || options === void 0 ? void 0 : options.analyticsChannel]);
  return remoteFrontendSdk;
};
export default useRemoteModule;